var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTimeCapsulesDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-time-capsules-nav",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 138.223,
    height: 139.745,
    viewBox: "0 0 138.223 139.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 138.223,
    height: 139.745,
    fill: "#1152e4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M132.778,128.856H67.759a42.054,42.054,0,0,0,3.88-3.415l53.8-53.8A41.966,41.966,0,0,0,66.093,12.291l-53.8,53.8a41.966,41.966,0,0,0,0,59.348,42.149,42.149,0,0,0,3.88,3.415h-9.7a5.444,5.444,0,1,0,0,10.888h126.3a5.444,5.444,0,0,0,0-10.888M74.38,53.115a7.06,7.06,0,1,1-7.059,7.059,7.067,7.067,0,0,1,7.059-7.059m-.589-33.124a31.077,31.077,0,0,1,43.95,43.95L95.094,86.589a55.664,55.664,0,0,0-5.313-16.621c-.054-.105-.116-.2-.176-.3A17.935,17.935,0,0,0,62.779,46.5a66.692,66.692,0,0,0-12.164-3.328Zm-62.9,75.776a30.871,30.871,0,0,1,9.1-21.975L40.719,53.064a57.79,57.79,0,0,1,16.216,2.9A17.936,17.936,0,0,0,80.993,76.855,51.73,51.73,0,0,1,85.087,96.6L63.94,117.742A31.077,31.077,0,0,1,10.888,95.767",
    fill: "#1152e4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeCapsulesDefault);
export default __webpack_public_path__ + "static/media/icon-time-capsules-default.1c999db79e3d9c86db1ea70eda420c13.svg";
export { ForwardRef as ReactComponent };